import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import PatientKitsList from 'components/Kits/PatientKitsList';

const PatientKits = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <PatientKitsList />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("kits")(PatientKits);
